import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';

import { connect } from 'react-redux';

import { factoryResetAgent } from '../../actions/basAgentActions';

import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';

import EsmsModal from '../../components/EsmsModal';
import CancelButton from '../../components/CancelButton';
import ConfirmButton from '../../components/ConfirmButton';

import { enqueueSnackbar } from '../../actions/applicationMessageActions';

import classes from './DeleteDeviceModal.module.css';

class ResetAgentModal extends Component {
    static defaultProps = {
        close:     () => {},
        open:      false,
        agentName: '',
        agentId:   ''
    };

    static propTypes = {
        agentName: string,
        agentId:   string,
        close:     func,
        open:      bool
    };

    state = {
        formIsValid: false
    }

    handleChange = event => {
        const formIsValid =
            event.target.value.toLowerCase() === 'reset';
        this.setState({ formIsValid });
    }

    handleClose = () => {
        this.props.close();
    }

    confirmFactoryReset = () => {
        this.props.factoryResetAgent(this.props.agentId);
        this.handleClose();
    }

    render() {
        const { open, agentName } = this.props;

        return (
            <EsmsModal
                imgSrc="/assets/images/basAgentIconColor.svg"
                open={open}
                onClose={this.handleClose}
                title={`Reset ${agentName} Agent`}
            >
                <p>Factory Resetting your Agent will restore the Agent to the latest Agent firmware and will remove any configurations from the Agent.</p>
                <p>You will need to sync a configuration to the Agent after the Factory Reset is complete.</p>
                <p>
                    To confirm, please type the word <span className={classes.warning}>RESET</span> in the field below.
                </p>
                <FormControl className={classes.fullWidth}>
                    <InputLabel
                        htmlFor="reset"
                        classes={{
                            focused: classes.labelFocused,
                            root:    classes.label
                        }}
                    >
                        Reset Confirmation
                    </InputLabel>
                    <Input
                        id="reset"
                        onKeyUp={this.handleChange}
                        name="reset"
                        classes={{
                            underline: classes.cssUnderline,
                            root:      classes.input
                        }}
                    />
                </FormControl>
                <div className={classes.buttonContainer}>
                    <CancelButton
                        cancel={this.handleClose}
                    />
                    <ConfirmButton
                        label="confirm"
                        type="button"
                        confirm={this.confirmFactoryReset}
                        disabled={!this.state.formIsValid}
                    />
                </div>
            </EsmsModal>
        );
    }
}

const mapDispatchToProps = {
    enqueueSnackbar,
    factoryResetAgent
};

export default connect(null, mapDispatchToProps)(ResetAgentModal);
